import { TextField, Label } from "@fluentui/react";
import React, { useContext } from "react";
import { ColumnOptionsContext } from "./ColumnOptions";
import { Column, TextFilter as TextFilterType } from "./types";

type Props = {
  column: Column;
};

export const TextFilter = ({ column }: Props) => {
  const filter = column.filter as TextFilterType;
  const { setFilter, strings } = useContext(ColumnOptionsContext);

  return (
    <div>
      <Label>{strings.textFilterLabel}</Label>
      <TextField
        value={filter.value}
        onChange={(_, value) => {
          setFilter(column.key, {
            ...filter,
            value: value ?? "",
          });
        }}
      />
    </div>
  );
};
